import moment from 'moment';
import * as types from '../mutation-types';
import api from '../../helpers/api';

const dateFormat = 'YYYY-MM-DD';

export default {
  state: {
    all: [],
  },
  getters: {
    getEvents: (state) => state.all,
  },
  actions: {
    async getAllEvents({ commit }) {
      const events = await api.get(`events/active?start=${moment().startOf('month').format(dateFormat)}&end=${moment().endOf('month').format(dateFormat)}`);
      commit(types.RECEIVED_EVENTS, { events });
    },
  },
  mutations: {
    [types.RECEIVED_EVENTS](state, { events }) {
      state.all = events;
    },
  },
};
